<h3>{{data.Title}}</h3>
<img [src]="data.ImageUrl" />